
import { CloseDropEventType } from './app.event.type';
import { AppEventDispatcher } from './utils/AppEventDispatcher';
import { Auth } from './autentication/Auth';
import { Component, ViewEncapsulation, HostListener, OnInit } from '@angular/core';
import { query, style, transition, trigger, animate } from '@angular/animations';
import { TweenMax, Power2 } from 'gsap';
import { ThemeService } from './shared/theme-service/theme.service';
import { AutenticationService } from './autentication/autentication.service';

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.styl'],
	encapsulation: ViewEncapsulation.None,
	animations: [
		trigger('routerAnimations', [
			transition('login => dashboard', [
				query(':leave',
					style({
						position: 'fixed',
						top: 0,
						width: '100%',
						height: '100%',
						zIndex: 1000
					}),
					{optional: true}),

				query(':leave',
					animate('0.6s .5s ease-out',
						style({
							transform: 'translateX(-100%)'
						})
					),
				{optional: true})
			]),
		])
	]
})

export class AppComponent implements OnInit {

	constructor (
		private themeService: ThemeService,
		private authService: AutenticationService
	) { }

  ngOnInit(): void {

  }

	prepareRoute(r) {
		return r.activatedRouteData.animation;
	}

	closeDrop() {

		AppEventDispatcher.dispatch(CloseDropEventType.CLOSE_DROP, {open: false});
		TweenMax.to('main .closeDrop', 0, { display: 'none' });

	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/app.component.ts